import { Theme } from '@mui/material';

export const paymentStepStyles = (theme: Theme) => ({
	donationDescription: {
		fontFamily: 'Montserrat',
		fontSize: '12px',
		fontWeight: 600,
		lineHeight: '21px',
		color: '#C6C6C6',
	},
	donationTier: (isSelected = false) => ({
		p: '4px 16px',
		minWidth: '62px',
		height: '30px',
		border: '1px solid #FFFFFF33',
		fontFamily: 'Hind',
		fontSize: '14px',
		fontWeight: 500,
		lineHeight: '20px',
		display: 'flex',
		gap: '10px',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: '20px',
		cursor: 'pointer',
		userSelect: 'none',
		color: isSelected ? '#000000' : '#FFFFFF',
		backgroundColor: isSelected ? '#FFFFFF' : undefined,

		"& >svg": {
			width: '13px',
			height: '13px',
		},

		"&:hover": {
			backgroundColor: isSelected ? '#FFFFFF' : '#FFFFFF33',
		},

		"&:disabled": {
			color: isSelected ? '#000000' : '#FFFFFF',
			opacity: 0.2,
		}
	}),
	appliedPromocode: {
		width: '102px',
		padding: '11px 15px',
		fontFamily: 'Montserrat',
		fontSize: '12px',
		fontWeight: 600,
		lineHeight: '15px',
		color: '#FFFFFF',
		display: 'flex',
		alignItems: 'center',
		gap: '4px',
		userSelect: 'none',

		"& >svg": {
			width: '19px',
			height: '19px',
		}
	},
	applyPromocodeButton: {
		width: '66px',
		marginTop: '1.5px',
		padding: '13px 15px',
		fontFamily: 'Montserrat',
		fontSize: '12px',
		fontWeight: 600,
		lineHeight: '15px',
		border: '1px solid #FFFFFF',
		color: '#FFFFFF',
		borderRadius: '25px',

		'&:hover': {
			background: '#FFFFFF',
			color: '#000000',
		},
		'&:disabled': {
			color: '#FFFFFF',
			opacity: 0.2,
		}
	},
});
